<template>
  <footer class="bg-secondary-500">
    <div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
      <div class="pb-8 xl:grid xl:grid-cols-5 xl:gap-8">
        <div class="grid grid-cols-2 gap-8 xl:col-span-4">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4
                class="text-sm leading-5 font-semibold text-secondary-400 tracking-wider uppercase"
              >
                getnext
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/#apply"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('Artist Sign up') }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h4
                class="text-sm leading-5 font-semibold text-secondary-400 tracking-wider uppercase"
              >
                {{ $t('Support') }}
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/portal/haeufige-fragen"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('FAQ') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4
                class="text-sm leading-5 font-semibold text-secondary-400 tracking-wider uppercase"
              >
                {{ $t('Company') }}
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/portal/ueber"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('About') }}
                  </a>
                </li>
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/portal/blog"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('Blog') }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h4
                class="text-sm leading-5 font-semibold text-secondary-400 tracking-wider uppercase"
              >
                {{ $t('Legal') }}
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/portal/datenschutz"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('Privacy Policy') }}
                  </a>
                </li>
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/portal/nutzungsbedingungen"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('Terms & Conditions') }}
                  </a>
                </li>
                <li>
                  <!-- TODO: rename routes -->
                  <a
                    href="/portal/impressum"
                    class="text-base leading-6 text-secondary-300 hover:text-white"
                  >
                    {{ $t('Imprint') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mt-12 xl:mt-0">
          <h4
            class="text-sm leading-5 font-semibold text-secondary-400 tracking-wider uppercase"
          >
            {{ $t('Language') }}
          </h4>
          <form class="mt-4 space-y-4 sm:max-w-xs">
            <fieldset class="w-full">
              <label for="language" class="sr-only">{{ $t('Language') }}</label>
              <div class="relative">
                <select
                  class="appearance-none block w-full bg-secondary-600 border border-transparent rounded-md py-2 pl-3 pr-10 text-base leading-6 text-white focus:outline-none focus:ring-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                  v-model="$root.$i18n.locale"
                >
                  <option
                    v-for="(lang, i) in langs"
                    :key="`Lang${i}`"
                    :value="lang"
                  >
                    {{ $t(lang) }}
                  </option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 px-2 flex items-center"
                  aria-hidden="true"
                >
                  <ChevronDownIcon class="h-4 w-4 text-white" />
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>

      <div
        class="mt-8 border-t border-gray-700 pt-8 md:flex md:items-center md:justify-between"
      >
        <div class="flex space-x-6 md:order-2">
          <!-- add social icons here -->

          <span class="text-secondary-400 text-xs">v{{ version }}</span>
        </div>
        <p
          class="mt-8 text-base leading-6 text-secondary-400 md:mt-0 md:order-1"
        >
          &copy; {{ currentYear }} Fans &amp; Fortune GmbH
        </p>
      </div>
    </div>
  </footer>
</template>

<i18n>
en:
  Language: Language
  Legal: Legal
  Privacy Policy: Privacy Policy
  Company: Company
  About: About
  Blog: Blog
  Imprint: Imprint
  Terms & Conditions: Terms & Conditions
  FAQ: FAQ
  Support: Support
  Artist Sign up: Artist Sign up

de:
  Language: Sprache
  Legal: Rechtliches
  Privacy Policy: Datenschutz
  Company: Unternehmen
  About: Über Uns
  Blog: Blog
  Imprint: Impressum
  Terms & Conditions: Nutzungsbedingungen
  FAQ: FAQ
  Support: Hilfe
  Artist Sign up: Künstler*innen-Anmeldung
</i18n>

<script>
import { ChevronDownIcon } from '@vue-hero-icons/outline'
import { version } from '../../../package.json'
import bus from '@/bus'
export default {
  name: 'getnextFooter',

  components: {
    ChevronDownIcon
  },

  data() {
    return {
      version,
      langs: ['de', 'en']
    }
  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },

  watch: {
    '$root.$i18n.locale'() {
      const locale = this.$i18n.locale
      this.$cookies.set('i18n', locale, -1, '/', null, true)
      bus.emit('i18nChanged', { locale })
      this.$formulate.setLocale(locale)
    }
  }
}
</script>
